export const MKT_ANALYTICS_DESIGN = {
    page: {
        container: 'px-4 md:px-8 lg:px-12 pb-8 pt-6 max-w-[1600px] mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500',
        header: {
            wrapper: 'flex items-center justify-between mb-6',
            left: 'flex items-center gap-4',
            iconBox: 'w-12 h-12 rounded-2xl flex items-center justify-center bg-violet-100',
            icon: 'text-violet-600',
            title: 'text-2xl font-bold text-gray-900',
            subtitle: 'text-sm text-gray-500',
            actionButton: 'flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95'
        }
    },
    tabs: {
        container: 'flex items-center gap-1 mb-6 bg-gray-100 rounded-xl p-1 w-fit',
        tab: 'px-4 py-2 text-sm font-medium rounded-lg cursor-pointer transition-all text-gray-500 hover:text-gray-700',
        tabActive: 'px-4 py-2 text-sm font-medium rounded-lg cursor-pointer transition-all bg-white text-violet-700 shadow-sm'
    },
    stats: {
        grid: 'grid grid-cols-2 md:grid-cols-4 gap-3 mb-6',
        card: 'bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3 hover:shadow-lg transition-all duration-300',
        iconBox: 'w-10 h-10 rounded-xl flex items-center justify-center',
        iconBoxViolet: 'bg-violet-50',
        iconBoxPink: 'bg-pink-50',
        iconBoxBlue: 'bg-blue-50',
        iconBoxGreen: 'bg-green-50',
        iconBoxAmber: 'bg-amber-50',
        value: 'text-xl font-bold text-gray-900',
        label: 'text-xs text-gray-500',
        growth: {
            positive: 'text-xs font-medium text-green-600 flex items-center gap-0.5',
            negative: 'text-xs font-medium text-red-600 flex items-center gap-0.5',
            neutral: 'text-xs font-medium text-gray-400 flex items-center gap-0.5'
        }
    },
    charts: {
        container: 'bg-white rounded-xl border border-gray-100 p-5 mb-4',
        title: 'text-sm font-semibold text-gray-900 mb-4',
        subtitle: 'text-xs text-gray-500 mb-4',
        grid2: 'grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4',
        grid3: 'grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4'
    },
    filters: {
        container: 'flex flex-wrap items-center gap-4 mb-6',
        label: 'text-xs font-semibold text-gray-500 uppercase tracking-wider',
        select: 'border border-gray-200 rounded-xl px-3 py-2 text-sm focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 focus:outline-none',
        dateInput: 'border border-gray-200 rounded-xl px-3 py-2 text-sm focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 focus:outline-none'
    },
    platformBadge: {
        instagram: 'text-xs font-medium flex items-center gap-1.5 bg-pink-50 text-pink-700 border border-pink-200 px-2 py-0.5 rounded-full',
        facebook: 'text-xs font-medium flex items-center gap-1.5 bg-blue-50 text-blue-700 border border-blue-200 px-2 py-0.5 rounded-full',
        google_ads: 'text-xs font-medium flex items-center gap-1.5 bg-amber-50 text-amber-700 border border-amber-200 px-2 py-0.5 rounded-full'
    },
    statusBadge: {
        active: 'text-xs font-medium flex items-center gap-1.5 bg-green-50 text-green-700 border border-green-200 px-2 py-0.5 rounded-full',
        expired: 'text-xs font-medium flex items-center gap-1.5 bg-red-50 text-red-700 border border-red-200 px-2 py-0.5 rounded-full',
        disconnected: 'text-xs font-medium flex items-center gap-1.5 bg-gray-50 text-gray-700 border border-gray-200 px-2 py-0.5 rounded-full',
        draft: 'text-xs font-medium flex items-center gap-1.5 bg-gray-50 text-gray-600 border border-gray-200 px-2 py-0.5 rounded-full',
        scheduled: 'text-xs font-medium flex items-center gap-1.5 bg-blue-50 text-blue-700 border border-blue-200 px-2 py-0.5 rounded-full',
        published: 'text-xs font-medium flex items-center gap-1.5 bg-green-50 text-green-700 border border-green-200 px-2 py-0.5 rounded-full',
        failed: 'text-xs font-medium flex items-center gap-1.5 bg-red-50 text-red-700 border border-red-200 px-2 py-0.5 rounded-full'
    },
    table: {
        container: 'bg-white rounded-xl border border-gray-100 overflow-hidden',
        header: 'px-5 py-3 border-b border-gray-100 flex items-center justify-between',
        headerTitle: 'text-sm font-semibold text-gray-900',
        row: 'px-5 py-3 border-b border-gray-50 flex items-center hover:bg-gray-50/50 transition-colors cursor-pointer',
        cell: 'text-sm text-gray-700',
        cellMuted: 'text-xs text-gray-500'
    },
    drawer: {
        overlay: 'fixed inset-0 z-[9999] flex justify-end',
        backdrop: 'absolute inset-0 bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-200',
        panel: 'relative w-[90%] max-w-3xl bg-white h-full shadow-2xl flex flex-col animate-in slide-in-from-right duration-300',
        header: 'px-6 py-4 border-b border-gray-100 flex items-center justify-between',
        headerIcon: 'w-10 h-10 rounded-xl flex items-center justify-center bg-violet-100',
        headerTitle: 'text-lg font-bold text-gray-900',
        headerSubtitle: 'text-sm text-gray-500',
        closeBtn: 'w-8 h-8 rounded-lg flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer',
        body: 'flex-1 overflow-y-auto p-6',
        footer: 'px-6 py-4 border-t border-gray-100 bg-gray-50/80 flex items-center justify-end gap-3',
        cancelBtn: 'px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-xl transition-colors',
        saveBtn: 'px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20'
    },
    emptyState: {
        container: 'flex flex-col items-center justify-center py-16',
        iconBox: 'w-16 h-16 rounded-2xl flex items-center justify-center bg-violet-50 mb-4',
        title: 'text-lg font-semibold text-gray-900 mb-1',
        subtitle: 'text-sm text-gray-500 mb-4 text-center max-w-sm',
        action: 'text-sm font-medium text-[#7C3AED] hover:text-[#6d28d9] cursor-pointer transition-colors'
    },
    form: {
        section: 'bg-white rounded-xl border border-gray-100 p-5 mb-4',
        sectionTitle: 'text-sm font-semibold text-gray-900 flex items-center gap-2 mb-4',
        label: 'text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1.5 block',
        input: 'w-full border border-gray-200 focus:border-[#7C3AED] focus:ring-2 focus:ring-[#7C3AED]/20 rounded-xl px-3 py-2.5 text-sm outline-none transition-all',
        textarea: 'w-full border border-gray-200 focus:border-[#7C3AED] focus:ring-2 focus:ring-[#7C3AED]/20 rounded-xl px-3 py-2.5 text-sm outline-none transition-all resize-none min-h-[120px]',
        checkbox: 'w-4 h-4 text-[#7C3AED] border-gray-300 rounded focus:ring-[#7C3AED]'
    },
    accounts: {
        grid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4',
        card: 'bg-white rounded-xl border border-gray-100 p-5 hover:shadow-lg transition-all duration-300 cursor-pointer',
        cardHeader: 'flex items-center gap-3 mb-3',
        avatar: 'w-12 h-12 rounded-xl object-cover',
        providerIcon: 'w-5 h-5 absolute -bottom-1 -right-1',
        cardInfo: 'flex-1 min-w-0',
        cardName: 'text-sm font-semibold text-gray-900 truncate',
        cardUsername: 'text-xs text-gray-500 truncate',
        cardStats: 'flex items-center gap-4 mt-3 pt-3 border-t border-gray-100',
        cardStat: 'text-center',
        cardStatValue: 'text-sm font-bold text-gray-900',
        cardStatLabel: 'text-[10px] text-gray-500 uppercase',
        cardFooter: 'flex items-center justify-between mt-3',
        syncText: 'text-[10px] text-gray-400',
        syncBtn: 'text-xs text-[#7C3AED] hover:text-[#6d28d9] font-medium cursor-pointer transition-colors'
    },
    calendar: {
        container: 'bg-white rounded-xl border border-gray-100 overflow-hidden',
        header: 'px-5 py-4 border-b border-gray-100 flex items-center justify-between',
        navBtn: 'w-8 h-8 rounded-lg flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer',
        monthTitle: 'text-sm font-semibold text-gray-900',
        grid: 'grid grid-cols-7',
        dayHeader: 'py-2 text-center text-xs font-semibold text-gray-500 uppercase border-b border-gray-100',
        day: 'min-h-[80px] border-b border-r border-gray-100 p-1',
        dayNumber: 'text-xs text-gray-500 mb-1',
        dayToday: 'text-xs text-white bg-[#7C3AED] rounded-full w-5 h-5 flex items-center justify-center mb-1',
        dayOther: 'text-xs text-gray-300 mb-1',
        postDot: 'w-1.5 h-1.5 rounded-full inline-block mr-0.5'
    }
};
